(function (Drupal, once) {
  'use strict';

  // Create or extend shared namespace
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Initialize Chapter 2 (Parranda) interactions
   */
  function initChapter2(svgContainer, svg, chapterState, sectionType) {
    // Get music notes element
    const musicNotes = svg.querySelector('#music-notes');
    const hotspot = svg.querySelector('#hotspot');
    const clickToPlay = svg.querySelector('#click-to-play');
    
    // Hide hotspot immediately
    if (hotspot) {
      hotspot.style.visibility = 'hidden';
      hotspot.style.display = 'none';
      hotspot.style.opacity = '0';
      hotspot.style.pointerEvents = 'none';
    }
    
    // Initialize audio
    let audio = null;
    let isPlaying = false;
    let isMuted = false;
    let noteAnimations = []; // Store animation references
    let hotspotActivated = false; // Track if hotspot has been clicked
    let isStartingAudio = false; // Prevent multiple simultaneous audio starts
    
    // Get base path for files
    let basePath = '';
    if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
      basePath = Drupal.settings.basePath;
    } else {
      const pathParts = window.location.pathname.split('/');
      const filtered = pathParts.filter(p => p);
      if (filtered.length > 0) {
        filtered.pop();
      }
      basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
    }
    basePath = basePath.replace(/\/$/, '');
    
    const audioPath = basePath + '/themes/custom/discoverpr_v2_theme/audio/mcmn-experience/chapter2.mp4';
    
    // Get audio control buttons from template
    // First, try to find the mcmn-svg-container (svgContainer might be the SVG element itself)
    let container = svgContainer;
    if (svg && svg.parentElement && svg.parentElement.classList && 
        svg.parentElement.classList.contains('mcmn-svg-container')) {
      container = svg.parentElement;
    }
    
    // Now find the section
    let section = null;
    if (container && container.closest) {
      section = container.closest('.mcmn-section');
    }
    // Fallback: search up the DOM tree if closest didn't find it
    if (!section) {
      let parent = container;
      while (parent && !section) {
        parent = parent.parentElement;
        if (parent && parent.classList && parent.classList.contains('mcmn-section')) {
          section = parent;
        }
      }
    }
    
    // If still no section, try searching for chapter 2 section directly
    if (!section) {
      section = document.querySelector('.mcmn-chapter-2');
    }
    
    const playButton = section ? section.querySelector('[data-mcmn-audio="play"]') : null;
    const pauseButton = section ? section.querySelector('[data-mcmn-audio="pause"]') : null;
    const muteButton = section ? section.querySelector('[data-mcmn-audio="mute"]') : null;
    
    // Check if buttons are found
    
    // Setup message to trigger play (hotspot is hidden)
    if (clickToPlay) {
      clickToPlay.style.cursor = 'pointer';
      clickToPlay.style.pointerEvents = 'auto';
      
      // Add hover effect
      // clickToPlay.addEventListener('mouseenter', function() {
      //   gsap.to(clickToPlay, {
      //     scale: 1.1,
      //     duration: 0.2,
      //     ease: 'power2.out',
      //   });
      // });
      
      // clickToPlay.addEventListener('mouseleave', function() {
      //   gsap.to(clickToPlay, {
      //     scale: 1,
      //     duration: 0.2,
      //     ease: 'power2.out'
      //   });
      // });
      
      // Click handler to start/resume audio
      const clickToPlayHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // If audio exists and is paused, resume it
        if (audio && !isPlaying) {
          startAudio();
          return;
        }
        
        // Prevent multiple clicks from starting audio multiple times (only on first start)
        if (hotspotActivated && isPlaying) {
          return;
        }
        
        // Mark hotspot as complete on first activation
        if (!hotspotActivated) {
          hotspotActivated = true;
          if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
            Mcmn.CookieManager.markHotspotComplete(sectionType, 'hotspot');
            // Check completion after marking hotspot
            if (Mcmn.checkCompletion) {
              const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
              Mcmn.checkCompletion(viewedSections);
            }
          }
        }
        
        startAudio();
      };
      clickToPlay.addEventListener('click', clickToPlayHandler);
      clickToPlay.addEventListener('touchend', clickToPlayHandler, { passive: false });
    }
    
    
    // Show play button, hide pause button
    function showPlayButton() {
      if (playButton) {
        playButton.style.setProperty('display', 'flex', 'important');
        playButton.style.visibility = 'visible';
      }
      if (pauseButton) {
        pauseButton.style.setProperty('display', 'none', 'important');
        pauseButton.style.visibility = 'hidden';
      }
    }
    
    // Show pause button, hide play button
    function showPauseButton() {
      if (pauseButton) {
        pauseButton.style.setProperty('display', 'flex', 'important');
        pauseButton.style.visibility = 'visible';
      }
      if (playButton) {
        playButton.style.setProperty('display', 'none', 'important');
        playButton.style.visibility = 'hidden';
      }
    }
    
    // Show audio controls after first interaction (only mute button, play/pause controlled separately)
    function showAudioControls() {
      if (muteButton) {
        muteButton.style.setProperty('display', 'flex', 'important');
        muteButton.style.visibility = 'visible';
      }
    }
    
    // Initialize: Hide all buttons initially until audio starts
    if (playButton) {
      playButton.style.setProperty('display', 'none', 'important');
    }
    if (pauseButton) {
      pauseButton.style.setProperty('display', 'none', 'important');
    }
    if (muteButton) {
      muteButton.style.setProperty('display', 'none', 'important');
    }
    
    // Start music notes animation
    function startMusicNotesAnimation() {
      if (!musicNotes) return;
      
      // Get all individual note elements within the music-notes group
      const notes = musicNotes.querySelectorAll('*');
      
      // Clear any existing animations
      noteAnimations.forEach(anim => anim.kill());
      noteAnimations = [];
      
      // Set initial state for smooth fade-in
      gsap.set(musicNotes, { 
        opacity: 0, 
        visibility: 'visible' 
      });
      
      // Smooth fade-in for music notes group
      gsap.to(musicNotes, {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out',
        onComplete: function() {
          // Start note animations after fade-in
          notes.forEach((note, index) => {
            // Reset position
            gsap.set(note, { y: 0 });
            
            // Create smooth up and down animation with slight delay for each note
            const delay = index * 0.1; // Stagger the animations
            const duration = 2 + (index % 3) * 0.5; // Vary duration slightly (2-3.5 seconds)
            const distance = 10 + (index % 5) * 2; // Vary movement distance (10-18px)
            
            const anim = gsap.to(note, {
              y: -distance,
              duration: duration,
              delay: delay,
              ease: 'power1.inOut',
              repeat: -1,
              yoyo: true
            });
            
            noteAnimations.push(anim);
          });
        }
      });
    }
    
    // Stop music notes animation
    function stopMusicNotesAnimation() {
      // Stop all animations
      noteAnimations.forEach(anim => anim.kill());
      noteAnimations = [];
      
      // Hide music notes
      if (musicNotes) {
        gsap.to(musicNotes, {
          opacity: 0,
          duration: 0.3,
          ease: 'power2.out',
          onComplete: function() {
            gsap.set(musicNotes, { visibility: 'hidden' });
            // Reset note positions
            const notes = musicNotes.querySelectorAll('*');
            notes.forEach(note => {
              gsap.set(note, { y: 0 });
            });
          }
        });
      }
    }
    
    // Start audio
    function startAudio() {
      // Prevent multiple simultaneous calls
      if (isStartingAudio) {
        return;
      }
      
      // Prevent multiple audio instances
      if (!audio) {
        audio = new Audio(audioPath);
        audio.loop = true;
        
        // Register this audio instance
        if (Mcmn.registerAudio) {
          Mcmn.registerAudio(sectionType, audio);
        }
        
        // Ensure looping works even if browser doesn't support loop attribute
        audio.addEventListener('ended', function() {
          if (isPlaying) {
            audio.currentTime = 0;
            audio.play().catch(error => {
              // Audio restart failed
            });
          }
        });
        
        audio.addEventListener('play', function() {
          isPlaying = true;
          isStartingAudio = false; // Reset flag when play event fires
          showPauseButton();
          showAudioControls();
          startMusicNotesAnimation();
        });
        
        audio.addEventListener('pause', function() {
          isPlaying = false;
          showPlayButton();
          stopMusicNotesAnimation();
        });
      }
      
      // Only play if not already playing
      if (!isPlaying && audio && !isStartingAudio) {
        isStartingAudio = true; // Set flag to prevent multiple calls
        audio.play().then(() => {
          // Ensure buttons are shown even if play event hasn't fired yet
          isStartingAudio = false; // Reset flag after play promise resolves
          showPauseButton();
          showAudioControls();
          startMusicNotesAnimation();
        }).catch(error => {
          isStartingAudio = false; // Reset flag on error
        });
      }
    }
    
    // Pause audio
    function pauseAudio() {
      if (audio && isPlaying) {
        audio.pause();
      }
    }
    
    // Toggle mute
    function toggleMute() {
      if (!audio) return;
      
      isMuted = !isMuted;
      audio.muted = isMuted;
      
      // Update mute button visual state
      if (muteButton) {
        if (isMuted) {
          muteButton.classList.add('muted');
        } else {
          muteButton.classList.remove('muted');
        }
      }
    }
    
    // Hide music notes initially
    if (musicNotes) {
      gsap.set(musicNotes, { opacity: 0, visibility: 'hidden' });
    }
    
    // Wire up play button (mobile touch support)
    if (playButton) {
      const playHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        startAudio();
      };
      playButton.addEventListener('click', playHandler);
      playButton.addEventListener('touchend', playHandler, { passive: false });
    }
    
    // Wire up pause button (mobile touch support)
    if (pauseButton) {
      const pauseHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        pauseAudio();
      };
      pauseButton.addEventListener('click', pauseHandler);
      pauseButton.addEventListener('touchend', pauseHandler, { passive: false });
    }
    
    // Wire up mute button (mobile touch support)
    if (muteButton) {
      const muteHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMute();
      };
      muteButton.addEventListener('click', muteHandler);
      muteButton.addEventListener('touchend', muteHandler, { passive: false });
    }

    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Kill all GSAP animations
          gsap.killTweensOf(musicNotes);
          gsap.killTweensOf(svg);
          gsap.killTweensOf(svgContainer);
          if (musicNotes) {
            const notes = musicNotes.querySelectorAll('*');
            notes.forEach(note => gsap.killTweensOf(note));
          }

          // Stop all note animations
          noteAnimations.forEach(anim => {
            if (anim && typeof anim.kill === 'function') {
              anim.kill();
            }
          });
          noteAnimations = [];

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }
        }
      });
    }
  }

  // Export functions to shared namespace
  Mcmn.initChapter2 = initChapter2;

})(Drupal, once);
